// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import Vant from 'vant'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

import './assets/common.css'
import './assets/index.scss'
import 'lib-flexible'
import 'lib-flexible/flexible.js'
import './assets/iconfont/iconfont.css'
import 'vant/lib/index.css'
import 'vant/lib/index.less'
// import 'vant/lib/toast/style/less'
import _ from 'lodash'; // 导入loadsh
Vue.prototype._ = _; //注入工具
import api from './utils/api'
import request from './utils/request'
import * as filters from './utils/filters'
import VueClipboard from 'vue-clipboard2'
import {
  CopyText
} from './utils/utils'

// 导入权限相关模块
import permission from './utils/permission'
import permissionDirective, { permissionClass, permissionDisabled } from './directives/permission'
// 编译 sql.js 错误,暂时注释了.如果有错误再处理
//import initSqlJs from "sql.js"
//import sqlWasm from "!!url-loader?name=sql-wasm-[contenthash].wasm!sql.js/dist/sql-wasm.wasm";
//import nfc from "./utils/ouu-nfc.js"
Vue.prototype.$api = api
Vue.prototype.$http = request
Vue.prototype.$CopyText = CopyText
// nfc.listenNFCStatus()
//Vue.prototype.$nfc = nfc
import BaiduMap from 'vue-baidu-map'
import draggableButton from 'vue-draggable-button'
Vue.use(draggableButton)

import {
  VueJsonp
} from 'vue-jsonp'
Vue.use(VueJsonp)

import VueTouch from 'vue-touch'
Vue.use(VueTouch, {
  name: 'v-touch'
})
VueTouch.config.swipe = {
  threshold: 50, //设置左右滑动的距离
  direction: "horizontal" //解决无法上下滑动
}
// import Mint from 'mint-ui'
// import 'mint-ui/lib/style.css'
// import './assets/mui/css/mui.min.css'
// import Mui from 'vue-awesome-mui';
// import Navigation from 'vue-navigation'
// import 'font-awesome/css/font-awesome.css'
// import Print from 'vue-print-nb'
// Vue.use(Print);  //注册
// import "./config/rem.js"

import getLocation from './utils/geo-location.js'
Vue.prototype.$api = api
Vue.prototype.$http = request
Vue.prototype.$store = store
Vue.prototype.$geoLocation = getLocation
const BAIDU_MAP_AK = process.env.VUE_APP_BAIDU_MAP_AK || 'bs33FsZE1aGasRoS5Neq9qashphsybre'
Vue.prototype.$baiduMapAk = BAIDU_MAP_AK
Vue.use(BaiduMap, {
  ak: BAIDU_MAP_AK
})

//抽奖
import LeeVue from 'leevueplugin'
Vue.use(LeeVue)

import {
  Swipe,
  SwipeItem,
  Picker,
  PullRefresh,
  List,
  ImagePreview,
  Area,
  Uploader,
  Lazyload,
  Popup,
  Icon,
  Badge,
  Dialog,
  Overlay,
  NavBar,
  Toast,
  Rate,
  Switch,
  NoticeBar,
  CountDown,
  Checkbox,
  CheckboxGroup
} from 'vant'
//vConsole 手机端在线调试 正式版注释掉 测试版可以打开
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
var option = {
  maxSpreadZoom: 2, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: false, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: false, //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
}
Vue.use(preview, option)


Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.use(Vant)
Vue.use(VueClipboard)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 注册权限相关组件
Vue.prototype.$permission = permission
Vue.directive('permission', permissionDirective)
Vue.directive('permission-class', permissionClass)
Vue.directive('permission-disabled', permissionDisabled)

Vue.use(Swipe).use(SwipeItem).use(Picker).use(PullRefresh).use(List).use(ImagePreview).use(Area)
  .use(Uploader).use(Lazyload).use(Popup).use(Icon).use(Badge).use(Dialog).use(Overlay).use(NavBar)
  .use(Toast).use(Rate).use(Switch).use(NoticeBar).use(Checkbox).use(CheckboxGroup).use(CountDown)
window.bus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event('x-app-rendered'))
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js